// src/services/userguide/userGuideService.js
import axios from "axios";
import { API } from "../../backend";     // Base API URL
import authHeader from "../auth-header"; // JWT token header

// Base endpoint (must end with slash)
const BASE = `${API}userguide/`;

const UserGuideService = {
  // =========================
  // 📘 GUIDES CRUD
  // =========================

  // Get all guides
  getGuides() {
    return axios.get(BASE, {
      headers: authHeader(),
    });
  },

  // Get one guide by ID
  getGuide(id) {
    return axios.get(`${BASE}${id}/`, {
      headers: authHeader(),
    });
  },

  // Create guide (PDF/DOCX upload)
  createGuide(data) {
    return axios.post(BASE, data, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // Update guide
  updateGuide(id, data) {
    return axios.put(`${BASE}${id}/`, data, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // Delete guide
  deleteGuide(id) {
    return axios.delete(`${BASE}${id}/`, {
      headers: authHeader(),
    });
  },

  // =========================
  // 🔍 SEARCH APIs
  // =========================

  // 🌍 Global search (navigation + all PDFs)
  globalSearch(query) {
    return axios.get(`${BASE}search/`, {
      params: { q: query },
      headers: authHeader(),
    });
  },

  // 📄 Search inside a single guide PDF
  searchInGuide(id, query) {
    return axios.get(`${BASE}${id}/search/`, {
      params: { q: query },
      headers: authHeader(),
    });
  },

  // =========================
  // 📄 PDF STREAM (NEW)
  // =========================

  /**
   * Returns a SAME-ORIGIN secured PDF URL
   * Used by react-pdf (PDF.js)
   */
  getGuidePdfUrl(id) {
    return `${BASE}${id}/pdf/`;
  },
};

export default UserGuideService;
